import { render, staticRenderFns } from "./FetchAccountDetails.vue?vue&type=template&id=abf62252&scoped=true"
import script from "./FetchAccountDetails.vue?vue&type=script&lang=js"
export * from "./FetchAccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf62252",
  null
  
)

export default component.exports